import { Component, OnInit } from '@angular/core';
import { CodaltComponent } from '../../codalt.component';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerService } from '../../services/customer/customer.service';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { Utils } from '../../utils.class';
import { Contact } from '../shared/contact';

@Component({
    selector: 'app-contact-detail',
    templateUrl: './contact-detail.component.html',
    styleUrls: ['./contact-detail.component.scss'],
    standalone: false,
})
export class ContactDetailComponent extends CodaltComponent implements OnInit {
    public Utils = Utils;

    contact: Contact = <Contact>{};
    contactId: number;
    customerId: number;
    projectId: number;

    constructor(
        private customerService: CustomerService,
        private confirmDialogService: ConfirmDialogService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit() {
        this.pageTitleService.setTitle('Contactpersoon');
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.projectId, this.RouteParamnames.contactId],
            ({ customerId, projectId, contactId }) => {
                this.customerId = +customerId;
                this.projectId = +projectId;
                this.contactId = +contactId;
            }
        );
        this.subscriptions.add(
            this.customerService.contact(this.customerId, this.contactId).subscribe(
                contact => {
                    this.contact = contact;
                    this.pageTitleService.setTitle('Contactpersoon', this.contact.name);
                },
                error => this.confirmDialogService.confirm('Kon contactpersoon niet ophalen', error, 'Oke')
            )
        );
    }
}
